import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const signedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (sessionStorage.getItem('token') === null) {
    return true;
  }

  return authService.isTermsAccepted().pipe(
    map((accepted) => {
      if (accepted) {
        router.navigate(['/']);
        return false;
      }
      return true;
    }),
  );
};
